if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.oriaviDesktopMql = window.matchMedia('(min-width: 990px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      this.setupOriaviDesktopNavigation();
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    getOriaviNavigationItems() {
      if (!this.elements.thumbnails) return [];

      return Array.from(this.elements.thumbnails.querySelectorAll('[data-target]')).filter((item) => {
        if (item.hidden) return false;
        const style = window.getComputedStyle(item);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    }

    setupOriaviDesktopNavigation() {
      if (!this.hasAttribute('data-oriavi-etsy-gallery')) return;

      this.oriaviPrevButton = this.elements.viewer.querySelector('.slider-buttons button[name="previous"]');
      this.oriaviNextButton = this.elements.viewer.querySelector('.slider-buttons button[name="next"]');

      if (!this.oriaviPrevButton || !this.oriaviNextButton) return;

      this.elements.viewer.enableSliderLooping = true;

      this.oriaviPrevButton.addEventListener('click', (event) => {
        this.onOriaviNavigationClick(event, -1);
      }, true);

      this.oriaviNextButton.addEventListener('click', (event) => {
        this.onOriaviNavigationClick(event, 1);
      }, true);

      this.oriaviDesktopMql.addEventListener('change', () => this.updateOriaviNavigation());
      this.updateOriaviNavigation();
    }

    onOriaviNavigationClick(event, direction) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const items = this.getOriaviNavigationItems();
      if (items.length < 2) return;

      let currentIndex = items.findIndex((item) => item.classList.contains('is-active') || item.querySelector('button[aria-current]'));
      if (currentIndex < 0) currentIndex = 0;

      const nextIndex = (currentIndex + direction + items.length) % items.length;
      this.setActiveMedia(items[nextIndex].dataset.target, false, false);
    }

    updateOriaviNavigation() {
      if (!this.oriaviPrevButton || !this.oriaviNextButton) return;

      const hasMultipleItems = this.getOriaviNavigationItems().length > 1;
      this.oriaviPrevButton.toggleAttribute('disabled', !hasMultipleItems);
      this.oriaviNextButton.toggleAttribute('disabled', !hasMultipleItems);
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      this.updateOriaviNavigation();
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.hasAttribute('data-oriavi-etsy-gallery') && this.oriaviDesktopMql.matches) {
        const list = this.elements.thumbnails.slider;
        const itemTop = thumbnail.offsetTop;
        const itemBottom = itemTop + thumbnail.offsetHeight;
        const visibleTop = list.scrollTop;
        const visibleBottom = visibleTop + list.clientHeight;

        if (itemTop < visibleTop || itemBottom > visibleBottom) {
          const targetTop = itemTop - ((list.clientHeight - thumbnail.offsetHeight) / 2);
          list.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
        }

        this.updateOriaviNavigation();
        return;
      }

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
